import { QueryObserverResult } from '@tanstack/react-query';
import memoize from 'lodash.memoize';

export type ApiResponse<Data, E = Error> =
  | {
      status: 'loading';
      data?: never;
      error?: never;
    }
  | {
      status: 'success';
      data: Data;
      error?: never;
    }
  | {
      status: 'error';
      error: E;
      data?: never;
    };

export type ApiResponseMethods<Data, E = Error> = {
  refetch(this: void): Promise<ApiResponse<Data, E>>;
};

export type ApiResponseWithMethods<Data, E = Error> = ApiResponse<Data, E> &
  ApiResponseMethods<Data, E>;

function _queryResultToApiResponse<Data, E>({
  status,
  data,
  error,
  refetch: queryRefetch,
}: QueryObserverResult<Data, E>): ApiResponseWithMethods<Data, E> {
  const refetch = (): Promise<ApiResponse<Data, E>> =>
    queryRefetch().then(_queryResultToApiResponse);
  switch (status) {
    case 'success':
      return { status: 'success', data, refetch };
    case 'error':
      return { status: 'error', error, refetch };
    case 'loading':
    default:
      return { status: 'loading', refetch };
  }
}

export const queryResultToApiResponse = memoize(_queryResultToApiResponse);
